const SLACK_URL =
  'https://slack.com/signin?redir=%2Foauth%3Fclient_id%3D51140871766.798107228705%26redirect_uri%3D%26state%3D%26scope%3Dcommands%252Cincoming-webhook%26user_scope%3D%26granular_bot_scope%3D0%26team%3D%26install_redirect%3D%26single_channel%3D0'
interface Props {
  onClose: () => void
}

export const Slack = ({ onClose }: Props) => {
  window.open(SLACK_URL, '_blank')
  onClose()

  return null
}
